import { useEffect } from "react";
import { highlightContainingMarkNoteElements } from "../../utils/reader/reader-notes";

const useHighlightContainingMarkNoteElements = (elContainer, ...additionalTriggers) => {
  useEffect(() => {
    if (elContainer) {
      highlightContainingMarkNoteElements(elContainer);
    }
  }, [elContainer, ...additionalTriggers]);
};

export default useHighlightContainingMarkNoteElements;
